import React from 'react';
import PropTypes from 'prop-types';
import '../containers/Home.css';

export function TagChipsFilter({ tags, selected, onToggle, onClear, className = '' }) {
  const selectedSet = new Set(Array.isArray(selected) ? selected : [...selected]);
  if (!tags || tags.length === 0) return null;

  return (
    <div className={`chips ${className}`}>
      <div className="chips__scroll">
        {tags.map((tag) => {
          const isSelected = selectedSet.has(tag);
          return (
            <button
              key={tag}
              type="button"
              className={`chip ${isSelected ? 'chip--selected' : ''}`}
              aria-pressed={isSelected}
              onClick={() => onToggle(tag)}
            >
              {tag}
            </button>
          );
        })}
        {selectedSet.size > 0 && (
          <button type="button" className="chip chip--clear" onClick={onClear}>
            Limpiar
          </button>
        )}
      </div>
    </div>
  );
}

TagChipsFilter.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.instanceOf(Set),
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  onToggle: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  className: PropTypes.string,
};


